/*
 * @Author: zhouwei
 * @Date: 2019-11-25 14:51:09
 * @Last Modified by: huangzq
 * @Last Modified time: 2021-03-05 14:23:47
 * @Desc: 新建推广页面
*/
<template>
  <div class="promotion-detail">
    <div class="header">
      <router-link
        to="/promotion/my-promotion"
        class="go-back"
      >
        <mk-iconfont
          icon-class="left"
          class="icon"
        ></mk-iconfont>
      </router-link>
      <div class="txt">
        推广详情
      </div>
    </div>
    <mk-tabs-biz
      v-model="activeName"
      class="el-tabs-mk-ui"
    >
      <mk-tab-pane
        v-for="(item, index) in tabs"
        :key="index"
        :label="item.label"
        :name="item.name"
      >
      </mk-tab-pane>
    </mk-tabs-biz>
    <!-- 需要保存操作数据的使用v-show -->
    <base-content
      v-show="activeName === 'content'"
      ref="baseContent"
    ></base-content>
    <base-data v-if="activeName === 'data'"></base-data>
    <form-data v-if="activeName === 'formData'"></form-data>
  </div>
</template>
<script>
import baseContent from './content/index.vue'
import baseData from './data/index.vue'
import formData from './formData/index.vue'
import { PROMOTIONAPIS } from '../../../../api'
export default {
  components: {
    baseContent,
    baseData,
    formData
  },
  data () {
    return {
      tabs: [
        {
          label: '推广内容',
          name: 'content'
        },
        {
          label: '推广数据',
          name: 'data'
        },
        {
          label: '表单数据',
          name: 'formData'
        }
      ],
      activeName: 'content'
    }
  },
  methods: {
    goBack () {
      // 返回
      this.$refs.baseContent.goBack()
    }
  }
}
</script>
<style lang="scss" scoped>
.promotion-detail {
  display: flex;
  height: 100%;
  flex-direction: column;

  a {
    text-decoration: none;
  }

  /deep/.el-tabs {
    flex-shrink: 0;

    .el-tabs__nav {
      padding: 10px 0;
    }
  }

  .header {
    width: 100%;
    height: 60px;
    box-sizing: border-box;
    box-shadow: 0 -1px 0 0 #e8e8e8 inset;
    display: flex;
    align-items: center;
    flex-shrink: 0;

    .go-back {
      height: 100%;
      padding: 0 8px 0 20px;
      cursor: pointer;
      display: flex;
      align-items: center;

      .icon {
        color: #000;
        font-size: 20px;
        font-weight: 500;
      }
    }

    .txt {
      font-weight: 500;
      font-size: 16px;
      line-height: 60px;
    }
  }
}
</style>
